var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 8.75C3.9375 5.45017 3.9375 3.80026 4.96262 2.77512C5.98776 1.75 7.63767 1.75 10.9375 1.75H12.25C15.5498 1.75 17.1998 1.75 18.2248 2.77512C19.25 3.80026 19.25 5.45017 19.25 8.75V12.25C19.25 15.5498 19.25 17.1998 18.2248 18.2248C17.1998 19.25 15.5498 19.25 12.25 19.25H10.9375C7.63767 19.25 5.98776 19.25 4.96262 18.2248C3.9375 17.1998 3.9375 15.5498 3.9375 12.25V8.75Z",
    stroke: "#003371",
    strokeWidth: 1.3125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9375 5.25H1.75M3.9375 10.5H1.75M3.9375 15.75H1.75",
    stroke: "#003371",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3631 7.42963C13.3631 8.3961 12.5796 9.17962 11.6132 9.17962C10.6468 9.17962 9.86328 8.3961 9.86328 7.42963C9.86328 6.46316 10.6468 5.67969 11.6132 5.67969C12.5796 5.67969 13.3631 6.46316 13.3631 7.42963Z",
    stroke: "#003371",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15667 13.7518C9.08275 12.3262 10.5534 11.7919 11.6174 11.793C12.6815 11.7941 14.1089 12.3262 15.0349 13.7518C15.0949 13.8441 15.1113 13.9575 15.0573 14.0534C14.8408 14.4374 14.1683 15.1994 13.6826 15.2511C13.1246 15.3105 11.6648 15.3188 11.6185 15.319C11.5721 15.3188 10.0673 15.3105 9.50897 15.2511C9.02334 15.1994 8.3509 14.4374 8.13433 14.0534C8.0803 13.9575 8.0968 13.8441 8.15667 13.7518Z",
    stroke: "#003371",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSupport);
export default __webpack_public_path__ + "static/media/contact-support.09f3d77d1ef0c20fe02386d63e9402f0.svg";
export { ForwardRef as ReactComponent };